// src/components/colleges.js

export const colleges = [
  {
    name: "MBM University",
    location: "Jodhpur, Rajasthan",
    coords: [26.2624, 73.0138], // [latitude, longitude]
    image: "https://api.mbm.ac.in/assets/5738229d-2fff-4e00-bae2-6331f18298b2", // यह टैग इमेज दिखाएगा
  },
   {
    name: "RTU Kota",
    location: "Kota, Rajasthan",
    coords: [25.1578, 75.8504],
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYKjo4vvDf4O6tKfKso6jBXD25Yk-cUvrraw&s",
  },
    {
    name: "CTAE Udaipur",
    location: "Udaipur, Rajasthan",
    coords: [24.6044, 73.7084],
    image: "https://www.ctae.ac.in/images/slider/large/img9268001.jpg",
  },
  {
    name: "SKIT Jaipur",
    location: "Jaipur, Rajasthan",
    coords: [26.8231 , 75.8666],
    image: "https://image-static.collegedunia.com/public/college_data/images/appImage/15381_SKIT_New.jpg",
  },
  {
    name: "JECRC Foundation",
    location: "Jaipur, Rajasthan",
    coords: [ 26.704394 , 75.830804],
    image: "https://jecrcuniversity.edu.in/wp-content/uploads/2023/06/Drone-Image-JU.png",
  },
 
  {
    name: "Poornima College of Engineering - PCE",
    location: "Jaipur, Rajasthan",
    coords: [26.7656, 75.8536],
    image: "https://www.poornima.org/uploads/albums/1716486380_1.jpg",
  },
];